/* NeonForge theme.js - vanilla JS, no dependencies */
(function () {
  'use strict';

  var T = window.theme || {};
  var routes = T.routes || {};

  /* ---------- Cart API ---------- */
  var Cart = {
    drawer: function () { return document.querySelector('[data-cart-drawer]'); },

    open: function () {
      var d = this.drawer();
      if (!d) { window.location.href = routes.cart; return; }
      d.classList.add('is-open');
      d.setAttribute('aria-hidden', 'false');
      document.body.classList.add('drawer-open');
      var panel = d.querySelector('.cart-drawer__panel');
      if (panel) panel.focus();
    },

    close: function () {
      var d = this.drawer();
      if (!d) return;
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('drawer-open');
    },

    updateCount: function (count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        el.hidden = !count;
      });
    },

    refresh: function () {
      var self = this;
      return fetch(routes.cart + '?section_id=cart-drawer')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-cart-drawer]');
          var current = self.drawer();
          if (fresh && current) {
            var wasOpen = current.classList.contains('is-open');
            current.innerHTML = fresh.innerHTML;
            if (wasOpen) current.classList.add('is-open');
          }
          return fetch(routes.cart_json).then(function (r) { return r.json(); });
        })
        .then(function (cart) { self.updateCount(cart.item_count); return cart; });
    },

    add: function (items) {
      var self = this;
      return fetch(routes.cart_add, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error(res.data.description || res.data.message || T.strings.error);
          return self.refresh();
        });
    },

    change: function (line, quantity) {
      var self = this;
      return fetch(routes.cart_change, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity })
      }).then(function () { return self.refresh(); });
    }
  };
  window.NeonCart = Cart;

  /* ---------- Delegated click handling ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;

    var cartToggle = t.closest('[data-cart-toggle]');
    if (cartToggle && T.cartType === 'drawer') {
      e.preventDefault();
      Cart.open();
      return;
    }
    if (t.closest('[data-cart-close]')) { Cart.close(); return; }

    var lineBtn = t.closest('[data-line-change]');
    if (lineBtn) {
      lineBtn.disabled = true;
      Cart.change(parseInt(lineBtn.dataset.lineChange, 10), parseInt(lineBtn.dataset.qty, 10));
      return;
    }

    var menuBtn = t.closest('[data-menu-toggle]');
    if (menuBtn) {
      var nav = document.getElementById(menuBtn.getAttribute('aria-controls'));
      var open = menuBtn.getAttribute('aria-expanded') === 'true';
      menuBtn.setAttribute('aria-expanded', String(!open));
      if (nav) nav.hidden = open;
      return;
    }

    var searchBtn = t.closest('[data-search-toggle]');
    if (searchBtn) {
      var box = document.getElementById(searchBtn.getAttribute('aria-controls'));
      var isOpen = searchBtn.getAttribute('aria-expanded') === 'true';
      searchBtn.setAttribute('aria-expanded', String(!isOpen));
      if (box) {
        box.hidden = isOpen;
        if (!isOpen) { var input = box.querySelector('input[type="search"]'); if (input) input.focus(); }
      }
      return;
    }

    var accTrigger = t.closest('[data-accordion-trigger]');
    if (accTrigger) { toggleAccordion(accTrigger); return; }

    var moreReviewsBtn = t.closest('[data-reviews-more]');
    if (moreReviewsBtn) {
      var sec = moreReviewsBtn.closest('[data-reviews-section]') || document;
      var step = parseInt((sec.dataset && sec.dataset.step) || '3', 10);
      var hiddenCards = Array.prototype.slice.call(sec.querySelectorAll('[data-extra-review][hidden]'));
      hiddenCards.slice(0, step).forEach(function (card) {
        card.hidden = false;
        card.classList.remove('is-hidden-review');
        card.classList.add('is-revealed-review');
      });
      if (hiddenCards.length <= step) {
        moreReviewsBtn.hidden = true;
      }
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      Cart.close();
      var menuBtn = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
      if (menuBtn) menuBtn.click();
    }
  });

  /* ---------- Accordion (smooth height) ---------- */
  function toggleAccordion(trigger) {
    var panel = document.getElementById(trigger.getAttribute('aria-controls'));
    if (!panel) return;
    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    trigger.setAttribute('aria-expanded', String(!expanded));
    if (expanded) {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () { panel.style.height = '0px'; });
      panel.addEventListener('transitionend', function done() {
        if (trigger.getAttribute('aria-expanded') === 'false') panel.hidden = true;
        panel.removeEventListener('transitionend', done);
      });
    } else {
      panel.hidden = false;
      panel.style.height = '0px';
      requestAnimationFrame(function () { panel.style.height = panel.scrollHeight + 'px'; });
    }
  }

  /* ---------- Countdown ---------- */
  function initCountdowns() {
    document.querySelectorAll('[data-countdown]').forEach(function (el) {
      var end = new Date(el.dataset.countdown).getTime();
      if (isNaN(end)) { el.hidden = true; return; }
      function pad(n) { return String(n).padStart(2, '0'); }
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var s = Math.floor(diff / 1000);
        el.querySelector('[data-cd-d]').textContent = pad(Math.floor(s / 86400));
        el.querySelector('[data-cd-h]').textContent = pad(Math.floor((s % 86400) / 3600));
        el.querySelector('[data-cd-m]').textContent = pad(Math.floor((s % 3600) / 60));
        el.querySelector('[data-cd-s]').textContent = pad(s % 60);
        if (diff === 0) { el.hidden = true; clearInterval(timer); }
      }
      var timer = setInterval(tick, 1000);
      tick();
    });
  }

  /* ---------- Carousel (scroll-snap) ---------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll('[data-slide]'));
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    var dotsBox = root.querySelector('[data-carousel-dots]');
    var dots = [];

    function perView() { return window.innerWidth >= 750 ? 2 : 1; }
    function pages() { return Math.max(1, Math.ceil(slides.length / perView())); }

    function buildDots() {
      if (!dotsBox) return;
      dotsBox.innerHTML = '';
      dots = [];
      for (var i = 0; i < pages(); i++) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'carousel__dot';
        b.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (idx) { b.addEventListener('click', function () { goTo(idx); }); })(i);
        dotsBox.appendChild(b);
        dots.push(b);
      }
    }

    function goTo(page) {
      var slide = slides[Math.min(slides.length - 1, page * perView())];
      if (slide) track.scrollTo({ left: slide.offsetLeft - track.offsetLeft, behavior: 'smooth' });
    }

    function current() {
      var width = track.clientWidth || 1;
      return Math.round(track.scrollLeft / width);
    }

    function update() {
      var page = Math.min(pages() - 1, current());
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === page); });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(pages() - 1, current() + 1)); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); goTo(Math.min(pages() - 1, current() + 1)); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(Math.max(0, current() - 1)); }
    });
    window.addEventListener('resize', function () { buildDots(); update(); });
    buildDots();
    update();
  }

  function init() {
    initCountdowns();
    document.querySelectorAll('[data-carousel]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  /* Re-init in the Theme Editor */
  document.addEventListener('shopify:section:load', init);
})();
